var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.18 6.774a1.045 1.045 0 112.09 0 1.045 1.045 0 01-2.09 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11.999 7.035a4.964 4.964 0 100 9.928 4.964 4.964 0 000-9.928zm-3.396 4.963a3.396 3.396 0 116.792 0 3.396 3.396 0 01-6.792 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M17.494 2.419a49.92 49.92 0 00-10.989 0c-2.102.235-3.8 1.891-4.047 4.004a47.943 47.943 0 000 11.15c.247 2.113 1.945 3.77 4.047 4.005 3.622.405 7.368.405 10.99 0 2.102-.235 3.8-1.892 4.047-4.005a47.938 47.938 0 000-11.15c-.247-2.113-1.945-3.769-4.048-4.004zM6.68 3.977a48.316 48.316 0 0110.642 0c1.39.155 2.503 1.252 2.664 2.63a46.419 46.419 0 010 10.784c-.161 1.377-1.274 2.474-2.664 2.629a48.312 48.312 0 01-10.642 0 3.019 3.019 0 01-2.664-2.63 46.415 46.415 0 010-10.784A3.019 3.019 0 016.68 3.977z"
  })));
}

export default "/images/instagram.svg?8af0d8c13ff095f55f5f5b5d029412943237183795557fd334e4265a2a63bbf6";
export { SvgInstagram as ReactComponent };